import { FC, useEffect } from 'react';

import { useRendererContext } from 'js/shared/contexts/RendererContext';

let mounted = false;
export const GoogleTagManager: FC = () => {
  const { isRenderer } = useRendererContext();

  useEffect(() => {
    if (isRenderer || mounted) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    const firstScript = document.getElementsByTagName('script')[0];
    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = `${import.meta.env.VITE_GTM_SERVER_URL}/gtm.js?id=${import.meta.env.VITE_GTM_TRACKING_ID}&l=dataLayer`;

    firstScript.parentNode?.insertBefore(gtmScript, firstScript);

    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `${import.meta.env.VITE_GTM_SERVER_URL}/gtag/js?id=${import.meta.env.VITE_GTM_TRACKING_ID}`;

    gtmScript.after(gtagScript);

    window.dataLayer.push(['js', new Date()]);
    window.dataLayer.push([
      'config',
      import.meta.env.VITE_GTM_TRACKING_ID,
      {
        transport_url: import.meta.env.VITE_GTM_SERVER_URL
      }
    ]);

    mounted = true;
  }, [isRenderer]);

  return null;
};
